export default __webpack_public_path__ + "static/pict5-ef991fce45ee3236026941faad39466a.png";